import React from 'react';
import DriverForm from '../components/DriverForm';
import DriverList from '../components/DriverList';
import useDrivers from '../hooks/useDrivers';

const DriversPage = ({ user }) => {
  // If no role, render nothing
  if (!user?.role) return null;

  const { drivers, addDriver, editDriver, removeDriver, editingDriver, setEditingDriver, genericSavedMsg } = useDrivers();
  const isConductor = user.role === "Conductor" || user.role === "conductor";

  return (
    <div className="space-y-6">
      {genericSavedMsg && (
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded">
          {genericSavedMsg}
        </div>
      )}
      {!isConductor && (
        <DriverForm
          onSave={editingDriver ? editDriver : addDriver}
          editingDriver={editingDriver}
          onCancelEdit={() => setEditingDriver(null)}
        />
      )}
      <DriverList
        drivers={drivers}
        onRemove={isConductor ? undefined : removeDriver}
        onEdit={isConductor ? undefined : setEditingDriver}
        isConductor={isConductor}
      />
    </div>
  );
};

export default DriversPage;